/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_No_EventsInputs */



/**
* | output |
* | --- |
* | "No events found to preview" |
*
* @param {Video_Export_Preview_No_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_no_events = /** @type {((inputs?: Video_Export_Preview_No_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_No_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun evenement a previsualiser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Ereignisse zur Vorschau gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento trovato da visualizzare in anteprima")
	if (locale === "ru") return /** @type {LocalizedString} */ ("События для предварительного просмотра не найдены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron eventos para previsualizar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到可预览的活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューするイベントが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वावलोकन के लिए कोई इवेंट नहीं मिले")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento encontrado para pré-visualização.")
	return /** @type {LocalizedString} */ ("No events found to preview")
});